import { TREND_NEW, TREND_SAME } from '@src/components/common/Trend';

export const getDodDiff = (metricTotal, dodTotal) => {
  try {
    if (isNaN(dodTotal)) {
      return null;
    }

    // value is Same if diff is 0, and New if prev is 0
    const diff = metricTotal - dodTotal;
    if (diff === 0) {
      return TREND_SAME;
    } else if (dodTotal === 0) {
      return TREND_NEW;
    }

    const trend = diff / dodTotal;
    return trend;
  } catch (err) {
    // pass
  }

  return null;
};
